import React from 'react';
import './style.scss';

const FitStatusDetails = ({ fitCount }) => {
    if (!fitCount || fitCount === 0) return null;
    return (
        <span className='fit-count'>
            {fitCount} {fitCount === 1 ? 'Fit' : 'Fits'}
        </span>
    );
}

FitStatusDetails.defaultProps = {
    fitCount: 0,
}

export { FitStatusDetails };